module.exports = __webpack_public_path__ + "img/badscience.3d77295c.jpg";